module.exports = __webpack_public_path__ + "assets/img/36_1510_big.59468521.jpg";